export default __webpack_public_path__ + "static/1644-076ee9d15ee96b819f30c8eb8b269317.gif";